import { Link } from 'react-router-dom';
import './PricingOverview.css';
import freeIcon from '../assets/free-icon.png';
import goldIcon from '../assets/gold-icon.png';
import platinumIcon from '../assets/platinum-icon.png';
import { useScrollReveal } from '../hooks/useScrollReveal';

function PricingOverview() {
    const [ref, visible] = useScrollReveal(0.1);
    const plans = [
        {
            icon: freeIcon,
            name: 'Free',
            price: 'Rp 0',
            tagline: 'No strings attached.',
            description:
                "Running a clinic shouldn't come with a paywall. Get full access to core operations like patients, appointments, staff, and invoicing, completely free.",
            highlights: ['Patient management', 'Appointments', 'Staff & roles', 'Invoicing'],
        },
        {
            icon: goldIcon,
            name: 'Gold',
            price: 'Rp 350.000',
            period: '/mo',
            tagline: 'Grow without limits.',
            description:
                'Unlock tools built for growing clinics. Sell treatment packages, track inventory in real-time, and run promos that keep patients coming back.',
            highlights: ['Treatment packages', 'Item stock tracking', 'Promo & reports', 'Everything in Free'],
            featured: true,
        },
        {
            icon: platinumIcon,
            name: 'Platinum',
            price: 'Custom',
            tagline: 'Built around you.',
            description:
                'For clinics that need more. We tailor the platform to your workflow, including commission reports, practitioner scheduling, and a dedicated support team by your side.',
            highlights: ['Commission reports', 'Practitioner schedules', 'Dedicated support', 'Everything in Gold'],
        },
    ];

    return (
        <section ref={ref} className={`pricing-overview ${visible ? 'visible' : ''}`}>
            <div className="pricing-overview-content">
                <h2>Simple, transparent pricing</h2>
                <p className="pricing-overview-subtitle">Start free. Upgrade when you're ready.</p>

                <div className="pricing-overview-grid">
                    {plans.map((plan, index) => (
                        <div key={index} className={`pricing-overview-card ${plan.featured ? 'featured' : ''}`}>
                            <div className="pricing-overview-card-header">
                                <img src={plan.icon} alt={plan.name} className="pricing-overview-icon" />
                                <h3>{plan.name}</h3>
                            </div>
                            <div className="pricing-overview-price">
                                <span className="price-amount">{plan.price}</span>
                                {plan.period && <span className="price-period">{plan.period}</span>}
                            </div>
                            <p className="pricing-overview-tagline">{plan.tagline}</p>
                            <p className="pricing-overview-description">{plan.description}</p>
                            <ul className="pricing-overview-highlights">
                                {plan.highlights.map((item, i) => (
                                    <li key={i}>
                                        <i className="fas fa-check"></i> {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="pricing-overview-cta">
                    <Link to="/pricing" className="pricing-overview-btn">
                        See detailed pricing <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default PricingOverview;
